import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Hammer, Users, Award, Wrench, ArrowRight } from "lucide-react";

const CRAFT = "https://images.unsplash.com/photo-1659930087003-2d64e33181f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxhcnRpc2FuJTIwd29vZHdvcmtpbmclMjBjcmFmdHNtYW5zaGlwfGVufDB8fHx8MTc4Mjg5MzU2N3ww&ixlib=rb-4.1.0&q=85";
const GALLERY = [
  "https://images.unsplash.com/photo-1580911498851-4999ad5327b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHx3b29kZW4lMjBzdGFpcmNhc2UlMjBtb2Rlcm58ZW58MHx8fHwxNzgzODMwOTE5fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1591638212063-c2f69701a931?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHx3b29kZW4lMjBzdGFpcmNhc2UlMjBtb2Rlcm58ZW58MHx8fHwxNzgzODMwOTE5fDA&ixlib=rb-4.1.0&q=85",
];

export default function ChiSiamo() {
  return (
    <div className="bg-craft">
      <section className="max-w-7xl mx-auto px-5 md:px-8 pt-14 md:pt-20 pb-10">
        <div className="grid md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-6">
            <div className="inline-flex items-center gap-2 text-xs tracking-widest uppercase text-primary bg-primary/5 border border-primary/20 rounded-full px-3 py-1">
              <span className="h-1.5 w-1.5 rounded-full bg-primary"></span> dal 1950 · pergine valdarno
            </div>
            <h1 className="font-display text-4xl md:text-6xl mt-4 leading-[1.05]">
              Tre generazioni di<br/><span className="italic text-primary">mani sapienti</span>.
            </h1>
            <p className="text-foreground/70 mt-5 max-w-xl">
              Nasciamo nel 1950 come piccola falegnameria di paese. Oggi Maurizi S.r.l.s. lavora legno, ferro e vetro
              per realizzare scale, ringhiere, parquet e infissi su misura, seguendo ogni cliente dal sopralluogo al
              montaggio finale.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Button asChild size="lg" className="rounded-full h-12 px-6">
                <Link to="/prenota">Prenota un appuntamento <ArrowRight className="h-4 w-4 ml-2" /></Link>
              </Button>
            </div>
          </div>
          <div className="md:col-span-6">
            <img src={CRAFT} alt="Artigiano al lavoro" className="rounded-2xl border border-border w-full h-[420px] md:h-[520px] object-cover" />
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid md:grid-cols-4 gap-5">
        <Stat icon={<Award className="h-4 w-4"/>} num="70+" label="anni di attività" />
        <Stat icon={<Users className="h-4 w-4"/>} num="3" label="generazioni in azienda" />
        <Stat icon={<Hammer className="h-4 w-4"/>} num="1.200+" label="progetti realizzati" />
        <Stat icon={<Wrench className="h-4 w-4"/>} num="24h" label="tempo di risposta" />
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-8 py-10">
        <div className="text-xs tracking-widest uppercase text-primary">Cosa facciamo</div>
        <h2 className="font-display text-3xl md:text-4xl mt-2 max-w-2xl">Legno, ferro e vetro. Su misura, come una volta.</h2>
        <div className="grid md:grid-cols-2 gap-5 mt-8">
          {[
            { t: "Scale interne ed esterne", d: "Progettazione e installazione di scale in legno massello, ferro battuto o soluzioni miste con vetro strutturale." },
            { t: "Ringhiere e parapetti", d: "Realizzazioni artigianali in ferro forgiato o in legno, dal design classico a quello contemporaneo." },
            { t: "Parquet", d: "Posa, levigatura e trattamento di parquet in rovere, castagno e essenze rare. Riparazioni puntuali su singole tavole." },
            { t: "Infissi", d: "Finestre e porte in legno, alluminio-legno e PVC. Manutenzione e sostituzione guarnizioni." },
          ].map((s) => (
            <div key={s.t} className="bg-white border border-border rounded-xl p-6 card-lift">
              <div className="font-display text-xl">{s.t}</div>
              <div className="text-sm text-foreground/70 mt-2">{s.d}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-8 py-10">
        <div className="text-xs tracking-widest uppercase text-primary">Progetti recenti</div>
        <h2 className="font-display text-3xl md:text-4xl mt-2">Lavori realizzati.</h2>
        <div className="grid md:grid-cols-2 gap-5 mt-8">
          {GALLERY.map((src, i) => (
            <div key={i} className="rounded-2xl overflow-hidden border border-border">
              <img src={src} alt="Progetto" className="w-full h-[360px] object-cover" />
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-8 py-16">
        <div className="rounded-2xl bg-foreground text-background p-8 md:p-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <div className="text-xs tracking-widest uppercase text-primary">Vieni a trovarci</div>
            <h3 className="font-display text-3xl md:text-4xl mt-2 text-background">Via Nazionale 84, Pergine Valdarno.</h3>
            <p className="text-background/70 mt-3">Show room aperto Lun–Ven 8:00–18:00, Sab 8:00–13:00.</p>
          </div>
          <Button asChild size="lg" className="rounded-full h-12 px-6 bg-primary hover:bg-[#256696]">
            <Link to="/prenota">Prenota una visita <ArrowRight className="h-4 w-4 ml-2" /></Link>
          </Button>
        </div>
      </section>
    </div>
  );
}

function Stat({ icon, num, label }) {
  return (
    <div className="bg-white border border-border rounded-xl p-5">
      <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-foreground/60">{icon} {label}</div>
      <div className="font-display text-4xl mt-2">{num}</div>
    </div>
  );
}
